import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {BALANCE_FEATURE_KEY} from '@store/balance/balance.types';
import {provideState} from '@ngrx/store';
import {provideEffects} from '@ngrx/effects';
import {balanceState} from '@store/balance/balance.state';
import {BRANCH_FEATURE_KEY} from '@store/branches/branch.types';
import {branchState} from '@store/branches/branch.state';
import {CATALOG_FEATURE_KEY} from '@store/catalog/catalog.types';
import {catalogState} from '@store/catalog/catalog.state';
import {CHECKOUTS_FEATURE_KEY} from '@store/checkouts/checkouts.types';
import {checkoutsState} from '@store/checkouts/checkouts.state';
import {HOLDS_FEATURE_KEY} from '@store/holds/holds.types';
import {holdsState} from '@store/holds/holds.state';
import {NOTIFICATIONS_FEATURE_KEY} from '@store/notifications/notifications.types';
import {notificationsState} from '@store/notifications/notifications.state';
import {ITEM_REQUESTS_FEATURE_KEY} from '@store/item-requests/item-requests.types';
import {itemRequestsState} from '@store/item-requests/item-requests.state';
import {ORGANIZATION_FEATURE_KEY} from '@store/organization/organization.types';
import {organizationState} from '@store/organization/organization.state';
import {PATRON_FEATURE_KEY} from '@store/patron/patron.types';
import {patronState} from '@store/patron/patron.state';
import {BalanceEffects} from '@store/balance/balance.effects';
import {BranchEffects} from '@store/branches/branch.effects';
import {CatalogEffects} from '@store/catalog/catalog.effects';
import {CheckoutsEffects} from '@store/checkouts/checkouts.effects';
import {HoldsEffects} from '@store/holds/holds.effects';
import {ItemRequestsEffects} from '@store/item-requests/item-requests.effects';
import {NotificationsEffects} from '@store/notifications/notifications.effects';
import {OrganizationEffects} from '@store/organization/organization.effects';
import {PatronEffects} from '@store/patron/patron.effects';
import {REGISTRATION_FEATURE_KEY} from '@store/registration/registration.types';
import {registrationState} from '@store/registration/registration.state';
import {RegistrationEffects} from '@store/registration/registration.effects';

export function providePhoenixStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(BALANCE_FEATURE_KEY, balanceState),
    provideState(BRANCH_FEATURE_KEY, branchState),
    provideState(CATALOG_FEATURE_KEY, catalogState),
    provideState(CHECKOUTS_FEATURE_KEY, checkoutsState),
    provideState(HOLDS_FEATURE_KEY, holdsState),
    provideState(NOTIFICATIONS_FEATURE_KEY, notificationsState),
    provideState(ITEM_REQUESTS_FEATURE_KEY, itemRequestsState),
    provideState(ORGANIZATION_FEATURE_KEY, organizationState),
    provideState(PATRON_FEATURE_KEY, patronState),
    provideState(REGISTRATION_FEATURE_KEY, registrationState),
    provideEffects([
      BalanceEffects,
      BranchEffects,
      CatalogEffects,
      CheckoutsEffects,
      HoldsEffects,
      ItemRequestsEffects,
      NotificationsEffects,
      OrganizationEffects,
      PatronEffects,
      RegistrationEffects,
    ])
  ]);
}
